class CustomVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.gallery = this.closest('.product').querySelector('media-gallery');
    this.allImages = this.gallery.querySelectorAll('.product__media-item');
    this.thumbnails = this.gallery.querySelectorAll('.thumbnail-list__item');
  }
  connectedCallback() {
    this.onVariantChange();
    this.addEventListener('change', this.onVariantChange.bind(this));
  }
  onVariantChange() {
    const selectedOptions = this.getSelectedOptions();
    this.updateVisibleImages(selectedOptions);
  }
  getSelectedOptions() {
    const variantSelects = this.querySelectorAll('select option[selected], fieldset input:checked');
    return Array.from(variantSelects)
        .filter(select => {
          const variantName = select.dataset.variantName ? select.dataset.variantName.toLowerCase() : '';
          const namePrefix = select.name ? select.name.toLowerCase().split('-')[0] : '';
          return namePrefix === variantName;
        })
        .map(select => select.value)
        .join(', ');
  }
  updateVisibleImages(selectedOptions) {
    this.updateElementsVisibility(this.allImages, selectedOptions);
    this.updateElementsVisibility(this.thumbnails, selectedOptions);
    const hasVisibleImages = this.hasVisibleElements(this.allImages);
    if (!hasVisibleImages) {
      this.showAllElements(this.allImages);
      this.showAllElements(this.thumbnails);
    }
  }
  updateElementsVisibility(elements, selectedOptions) {
    let isFirst = true;
    elements.forEach(element => {
      if (isFirst) {
        isFirst = false;
        return;
      }
      const image = element.querySelector('img[data-variant]');
      if (!image) return;
      const variantValues = image.dataset.variant.split(',').map(v => v.trim());
      const shouldShow = variantValues.includes(selectedOptions);
      element.classList.toggle('hidden', !shouldShow);
    });
  }
  hasVisibleElements(elements) {
    return Array.from(elements).some(element => !element.classList.contains('hidden'));
  }
  showAllElements(elements) {
    elements.forEach(element => {
      element.style.display = '';
      element.classList.remove('hidden');
    });
  }
}
customElements.define('custom-variant-selects', CustomVariantSelects);
